import React, {useEffect, useState} from 'react'
import '../css/investor.css'
import Background from "../components/assets/img/bg.jpg";
import {useWeb3React} from "@web3-react/core";
import {Web3Provider} from "@ethersproject/providers";
import {
    addPhetaToken,
    getCampaignContract,
    getInvestedAmount,
    getPhetaTokenContract,
    prettyPrintBigNumber
} from "../utils";
import {PhenomCampaign} from "../contracts/PhenomCampaign";


export function InvestorCheckPage({language, buyHandler}) {
    const { active, account, library, connector, activate, setError, deactivate } = useWeb3React<Web3Provider>()
    const [unlocked, setUnlocked] = useState<string>('Loading...')
    const [locked, setLocked] = useState<string>('Loading...')
    const [releasable, setReleasable] = useState<boolean>()
    const [releasing, setReleasing] = useState<boolean>(false)
    const [campaignContract, setCampaignContract] = useState<PhenomCampaign>()

    useEffect(() => {
        (async () => {
            const contract = await getCampaignContract(library)
            setCampaignContract(contract)

            const released = await contract.getReleasedAmount()
            const available = await contract.getAvailableAmount()
            setUnlocked(prettyPrintBigNumber(available))
            setReleasable(!available.isZero())

            const invested = await getInvestedAmount(contract, account)
            const _locked = invested.sub(available).sub(released)
            setLocked(prettyPrintBigNumber(_locked))
        })().then()
    }, [releasing, account])

    const release = async () => {
        if (releasing) return

        setReleasing(true)

        await addPhetaToken(await getPhetaTokenContract(library), account)

        try {
            const tx = await campaignContract.releaseAvailable()
            await tx.wait()
        } catch (e) {
            console.error(e)
        }
        setReleasing(false)
    }

    return (
        <section className={'ip'} style={{backgroundImage: `url(${Background})`}}>
            <div className={'ip-content'}>
                <div className="ip-content-container">
                    <p className={'ip-address'}>{language === 'ru' ? 'Ваш адрес' : 'Your address'}: <span>{account}</span></p>
                    <div className="ip-info">
                        <div className="ip-info-one">
                            <h2 className={'ip-info-title-one'}>{language === 'ru' ? 'Заблокированые фета токены' : 'PHETA token locked'}:</h2>
                            <p className={'ip-info-value-one'}>{locked}</p>
                        </div>
                        <div className="ip-info-two">
                            <h2 className={'ip-info-title-two'}>{language === 'ru' ? 'Разблокированые фета токены' : 'PHETA token unlocked'}:</h2>
                            <p className={'ip-info-value-two'}>{unlocked}</p>
                        </div>
                    </div>
                    <div className={'ip-btns'}>
                        { releasable &&
                            <a className={'ip-btn-one'} onClick={release}>
                                {releasing
                                    ? 'Executing...'
                                    : (language === 'ru' ? `Получить ${unlocked} токенов` : `get ${unlocked} tokens`)
                                }
                            </a>
                        }
                        <a className={'ip-btn-two'} onClick={buyHandler}>{language === 'ru' ? 'Купить еще' : 'buy more'}</a>
                    </div>
                </div>
            </div>
        </section>
    )
}
























